// extracted by mini-css-extract-plugin
export default {"directLink":"direct-link-module--direct-link--ke-uh"};